/*
 * Moonji bundle picker.
 * The catalogue is five bundle products x five variants. Picking a case size and a
 * mode (mixed / one flavour) resolves to exactly one variant, added as a single line.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-bundle-picker]');
  if (!root) return;

  var configEl = root.querySelector('[data-picker-config]');
  if (!configEl) return;
  var config = JSON.parse(configEl.textContent);

  var sizeInputs = root.querySelectorAll('input[name="case-size"]');
  var modeInputs = root.querySelectorAll('input[name="case-mode"]');
  var flavourInputs = root.querySelectorAll('input[name="case-flavour"]');
  var flavourSet = root.querySelector('[data-flavours]');
  var summaryEl = root.querySelector('[data-summary]');
  var addBtn = root.querySelector('[data-add-case]');

  function checkedValue(inputs, fallback) {
    for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i].value;
    return fallback;
  }

  function currentCase() {
    var size = Number(checkedValue(sizeInputs, 0));
    for (var i = 0; i < config.cases.length; i++) {
      if (config.cases[i].size === size) return config.cases[i];
    }
    return null;
  }

  function currentMode() {
    return checkedValue(modeInputs, 'mixed');
  }

  function flavourLabel(key) {
    for (var i = 0; i < config.flavours.length; i++) {
      if (config.flavours[i].key === key) return config.flavours[i].label;
    }
    return key;
  }

  // The selected size + mode (+ flavour) resolve to one variant, or null if the
  // combination does not exist in Shopify.
  function selectedVariant() {
    var c = currentCase();
    if (!c) return null;
    if (currentMode() === 'mixed') return c.mixed;
    return c.byFlavour[checkedValue(flavourInputs, '')] || null;
  }

  function render() {
    var c = currentCase();
    var mode = currentMode();
    var variant = selectedVariant();

    // Flavour tiles are inert in mixed mode; the whole fieldset carries the state.
    flavourSet.disabled = mode !== 'single';
    root.classList.toggle('is-single', mode === 'single');

    flavourInputs.forEach(function (input) {
      var tile = input.closest('.flavour-opt');
      var entry = c ? c.byFlavour[input.value] : null;
      tile.classList.toggle('is-soldout', !entry || !entry.available);
    });

    if (!c) {
      summaryEl.textContent = '';
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }

    if (mode === 'mixed') {
      summaryEl.textContent = config.labelEach
        .replace('[each]', c.each)
        .replace('[total]', c.size);
    } else {
      summaryEl.textContent = c.size + ' tubs of ' + flavourLabel(checkedValue(flavourInputs, ''));
    }

    if (!variant || !variant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
      return;
    }

    addBtn.disabled = false;
    var perTub = window.moonji.money(Math.round(variant.price / c.size));
    addBtn.textContent = config.ctaLabel + ' — ' + window.moonji.money(variant.price) + ' (' + perTub + '/tub)';
  }

  sizeInputs.forEach(function (i) { i.addEventListener('change', render); });
  modeInputs.forEach(function (i) { i.addEventListener('change', render); });
  flavourInputs.forEach(function (i) { i.addEventListener('change', render); });

  // Hero quantity pills: land on the picker with that size already selected.
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-preselect-size]');
    if (!pill) return;
    var size = pill.dataset.preselectSize;
    for (var i = 0; i < sizeInputs.length; i++) {
      if (sizeInputs[i].value === size) {
        sizeInputs[i].checked = true;
        render();
        return;
      }
    }
  });

  addBtn.addEventListener('click', function () {
    if (addBtn.disabled) return;
    var variant = selectedVariant();
    if (!variant) return;
    var restore = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding your case…';

    window.moonji.addToCart([{ id: variant.id, quantity: 1 }]).then(function () {
      addBtn.textContent = '✓ Case added';
      // Only route checkout through the discount deep-link once the voucher is live.
      if (config.discount.active && config.discount.code) {
        document.querySelectorAll('.js-checkout-link').forEach(function (a) {
          a.setAttribute('href', '/discount/' + encodeURIComponent(config.discount.code) + '?redirect=%2Fcheckout');
        });
      }
      setTimeout(render, 2000);
    }).catch(function () {
      addBtn.textContent = 'Something went wrong. Try again';
      addBtn.disabled = false;
      setTimeout(function () { addBtn.textContent = restore; render(); }, 2500);
    });
  });

  render();
})();
